import React, { createRef, useState } from 'react';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch } from 'react-instantsearch-dom';
import styled, { ThemeProvider } from 'styled-components';
import Color from 'color';
import { SearchBox } from './SearchBox';
import { SearchResults } from './SearchResults';
import { theme, media, color } from '../../theme';
import { vr } from '../../utils';

export default function Search({ indices }) {
  const rootRef = createRef();
  const [ query, setQuery ] = useState();
  const searchClient = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID,
    process.env.GATSBY_ALGOLIA_SEARCH_KEY,
  );

  return (
    <StyledSearchRoot ref={rootRef}>
      <InstantSearch
        searchClient={searchClient}
        indexName={indices[0].name}
        onSearchStateChange={(s) => setQuery(s.query)}
      >
        <StyledSearchBox />
        { typeof query === 'string' && query.length > 0 && (
          <StyledSearchResults indices={indices} />
        )}
      </InstantSearch>
    </StyledSearchRoot>
  );
}

const StyledSearchBox = styled(SearchBox)`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin-bottom: 0;
`;

const StyledSearchResults = styled(SearchResults)`
  .HitCount {
    display: block;
    margin-top: ${vr(0.25)};
  }

  mark {
    background: ${color.yellow};
  }

  .ais-Snippet {
    display: block;
    /* margin-top: 0.5rem; */

    &:after {
      content: "...";
    }
  }

  h3 a:after {
    display: none;
  }

  .Hits {
    ul {
      list-style: none;
      margin-left: 0;
      max-width: ${theme.contentMaxWidth};
    }
    li.ais-Hits-item {
      margin-bottom: 2em;

      a {
        h4 {
          margin-bottom: 0.2em;
        }
      }
    }
  }
  .ais-PoweredBy {
    display: flex;
    justify-content: flex-end;
    font-size: 80%;

    svg {
      width: 70px;
      margin-left: 0.2em;

      linearGradient stop {
        &:nth-child(1) {
          stop-color: ${Color(theme.footerBackgroundColor).lighten(0.25)};
        }

        &:nth-child(2) {
          stop-color: ${Color(theme.footerBackgroundColor).lighten(0.5)};
        }
      }
    }
  }
`;

const StyledSearchRoot = styled.div`
  position: relative;
  margin: 0.6em 0;
`;
